import React, {useCallback, useState} from 'react';
import Button from "@amzn/meridian/button";
import Icon from "@amzn/meridian/icon";
import {FormattedMessage, injectIntl} from "react-intl";
import Row from "@amzn/meridian/row";
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Column from "@amzn/meridian/column";
import plusCircleTokens from "@amzn/meridian-tokens/base/icon/plus-circle";
import Text from "@amzn/meridian/text";
import Textarea from "@amzn/meridian/textarea";

const AddEditViaJsonModal = (props) => {

    const {formatMessage} = props.intl;
    const [openModal, setOpenModal] = useState(false)
    const [valueConfigurationJson, setValueConfigurationJson] = useState("")
    const [reload, setReload] = useState(false)

    const onCloseModal = useCallback(() => setOpenModal(false), [])

    function onClickCancel() {
        setInputState();
        setOpenModal(false)
    }

    const stateValues = {
        "configurationJson": valueConfigurationJson,
    }

    const onClickAddEditConfiguration = useCallback(() => setOpenModal(true), [])
    const onClickConfirm = useCallback(async (stateValues) => {
        setReload(true)
    }, [reload]);

    function setInputState() {
        // setting state of input fields as empty to have empty inputs on clicking Add Device again
        setValueConfigurationJson("");
    }

    return (
        <Row>
            <Button onClick={onClickAddEditConfiguration}
                    type="tertiary"
                    size="small">
                <Icon tokens={plusCircleTokens}/>
                <FormattedMessage id="button.add" defaultMessage="Add/Edit via JSON"/>
            </Button>
            <Modal
                title={formatMessage({id: "device.edit_config"})}
                open={openModal}
                onClose={onCloseModal}
                scrollContainer="viewport"
                closeLabel="Close"
                bodySpacingInset="medium">
                <Column spacing={"medium"} spacingInset={"medium"}>
                    <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                        <FormattedMessage id="modal.config" defaultMessage="Fill in the configuration JSON."/>
                    </Text>
                    <Textarea
                        id="my-input"
                        width="800"
                        value={valueConfigurationJson}
                        onChange={setValueConfigurationJson}
                        rows={12}
                        resize="none"
                    />
                </Column>
                <ModalFooter>
                    <Row alignmentHorizontal="right" widths="fit">
                        <Button type="secondary" size="medium" onClick={onClickCancel}>
                            <FormattedMessage id="modal.cancel" defaultMessage="Cancel"/>
                        </Button>
                        <Button type="primary"
                                size="medium"
                                onClick={() => onClickConfirm(stateValues)}>
                            <FormattedMessage id="modal.confirm" defaultMessage="Confirm"/>
                        </Button>
                    </Row>
                </ModalFooter>
            </Modal>
        </Row>
    )
}

export default injectIntl(AddEditViaJsonModal);



// WEBPACK FOOTER //
// ./src/components/commonui/AddEditViaJsonModal.js